<div class="container" *ngIf="!newDesign; else newDesign">
  <ng-container *ngIf="!lateralList">
    <app-product-card
      class="w-1/5 sm:w-1/2 md:w-1/4 lg:w-1/5"
      *ngFor="let product of productLists"
      [product]="product"
      (action)="onAction($event)"
    ></app-product-card>
  </ng-container>

  <div class="product-list-swiper">
    <swiper-container #swiperRef [init]="false">
      <swiper-slide *ngFor="let product of productLists">
        <app-product-card
          [product]="product"
          [lateralList]="lateralList"
          (action)="onAction($event)"
        ></app-product-card>
      </swiper-slide>
      <div class="swiper-pagination"></div>
    </swiper-container>
  </div>
</div>

<ng-template #newDesign>
  <div *ngIf="loading" class="loader-container">
    <ion-spinner></ion-spinner>
  </div>
  <div [ngStyle]="{ display: loading ? 'none' : 'block' }">
    <div class="product-list-swiper">
      <swiper-container #swiperRef [init]="false">
        <swiper-slide *ngFor="let product of productLists">
          <app-product-card
            [ngClass]="{
              'in-cart-preview': lateralList,
              'in-page': !lateralList,
            }"
            [product]="product"
            [lateralList]="lateralList"
            [smallLabels]="smallLabels"
            [context]="lateralList ? 'cart-preview' : 'product-page'"
            (action)="onAction($event)"
          ></app-product-card>
        </swiper-slide>
        <div class="swiper-pagination"></div>
      </swiper-container>
    </div>
  </div>
</ng-template>
